<script setup>
import { ref, defineProps} from 'vue'

const props = defineProps(['field'])
const field = ref(props.field)

</script>

<template>
  <div class="container">
    <iframe :src="field?.liveurl"></iframe>
  </div>
</template>

<style scoped>
.container iframe{
  height: 55vh;
  width: 100%;
}
</style>
